export const INTAKE_SUBMISSION_STATUS = {
  draft: 'draft',
  submitted: 'submitted',
  accepted: 'accepted',
  returned: 'returned',
} as const;

export type IntakeSubmissionStatus =
  (typeof INTAKE_SUBMISSION_STATUS)[keyof typeof INTAKE_SUBMISSION_STATUS];
